module.exports = __webpack_public_path__ + "static/media/bgSound.3fd02da5.mp3";